<template id="input-template">
  <div class="field" :class="{ 'has-focus': focused }">
    <div class="heading">
      <label :for="label">{{ label }}</label>
    </div>
    <div class="input">
      <slot v-if="isAllowed" />
      <div v-else class="readonly">
        <span v-if="value">{{ value }}</span>
        <span v-else>-</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  template: '#input-template',
  props: ['label', 'value', 'isAllowed'],
  data() {
    return {
      focused: false
    };
  }
};
</script>
